"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class DataSourceMapper {
    constructor(getDataSource, putDataSource, deleteDataSource, toOutMapper, toInMapper) {
        this.getDataSource = getDataSource;
        this.putDataSource = putDataSource;
        this.deleteDataSource = deleteDataSource;
        this.toOutMapper = toOutMapper;
        this.toInMapper = toInMapper;
    }
    async get(queryOrId) {
        let result = await this.getDataSource.get(queryOrId);
        return this.toOutMapper.map(result);
    }
    async getAll(queryOrIds) {
        let results = await this.getDataSource.getAll(queryOrIds);
        return results.map((r) => this.toOutMapper.map(r));
    }
    async put(value, queryOrId = new __1.VoidQuery()) {
        let mapped = this.toInMapper.map(value);
        let result = await this.putDataSource.put(mapped, queryOrId);
        return this.toOutMapper.map(result);
    }
    async putAll(values, queryOrIds = new __1.VoidQuery()) {
        let mapped = this.toInMapper.map(values);
        let results = await this.putDataSource.putAll(mapped, queryOrIds);
        return results.map((r) => this.toOutMapper.map(r));
    }
    delete(queryOrId) {
        return this.deleteDataSource.delete(queryOrId);
    }
    deleteAll(queryOrIds) {
        return this.deleteDataSource.deleteAll(queryOrIds);
    }
}
exports.DataSourceMapper = DataSourceMapper;
